import { BrowserRouter, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './components/components.css';
import PublicRoute from './PublicRoute';
import ProtectedRoute from './Protected';
import AppLayout from './AppLayout';
import Login from './Pages/Auth/Login';
import Dashboard from './Pages/Home';
import Translate from './Pages/Translate';
import NotFound from './components/NotFound';
import Users from './Pages/Users';
import UserDetail from './Pages/Users/UserDetail';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* PUBLIC ROUTES */}
        <Route
          element={
            <PublicRoute>
              <AppLayout />
            </PublicRoute>
          }
        >
          <Route path="/login" element={<Login />} />
        </Route>
        <Route
          element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          }
        >
          <Route path="*" element={<NotFound />} />
          <Route path="/" element={<Translate />} />
          <Route path="/users" element={<Users />} />
          <Route path="/users/:id" element={<UserDetail />} />
          <Route path="/translate" element={<Translate />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
